import React from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import useLanguageChange from "../../hooks/useLanguageChange";
import { showExpandView } from "./GalleryViewUtils";
import { setPinForScreenShare } from "../../reducers/gallery-view-reducer";

const PinVideoForAllParticipantsButton = ({ stremingIdentity, isScreenShare }) => {
    const localisedValues = useLanguageChange();
    const dispatch = useDispatch();
    const handlePinVideoButton = () => {
        console.log(stremingIdentity);
        dispatch(setPinForScreenShare(isScreenShare));
        showExpandView(stremingIdentity, true);
    };

    return (
        <div className='video-action-button'>
            <button className='btn' onClick={handlePinVideoButton}>
                <div className='video-action-button-in'>
                    <span className='for-icon icon-expand-video'></span>
                    <span className='for-text'>{localisedValues.pin_video_for_all_participants}</span>
                </div>
            </button>
        </div>
    );
};
PinVideoForAllParticipantsButton.propTypes = {
    stremingIdentity: PropTypes.any,
    isScreenShare: PropTypes.bool,
};
export default PinVideoForAllParticipantsButton;
